import { MEMBERSHIPS_IMAGE_URL } from 'enums/memberships'
import { OutletPresenter } from 'shared/presenters'
import { Outlets, Membership_Products } from 'shared/presenters/graphqlTypes'
import { RecursivePartial } from 'shared/presenters/presenter'
import { generateCloudinaryUrl } from 'shared/helpers/generateCloudinaryUrl'
import { TransformationKeys } from 'shared/enums/image'

/**
 * On the home page we show UI 'cards' to represent categories/groups of chargeables
 * This function is for determining the most appropriate image to use in the CoverImage for that card
 */
const determineMembershipImage = ({
  outlet,
  membership,
  transform = 'chargeable'
}: {
  outlet: Outlets | OutletPresenter
  membership: RecursivePartial<Membership_Products>
  transform?: Extract<TransformationKeys, 'chargeable' | 'fullscreen'>
}) => {
  if (membership.image)
    return generateCloudinaryUrl(membership.image, transform)

  const imageKeySrc = outlet.membership_key_image

  if (imageKeySrc) return MEMBERSHIPS_IMAGE_URL
  // Currently the outlet's membership_key_image is not being used
  // Replace the above line with the following line to use it
  // return generateCloudinaryUrl(imageKeySrc, transform)

  return MEMBERSHIPS_IMAGE_URL
}

export default determineMembershipImage
